import { orderTransactionTypes } from '@/constants'

import ExchangeMessage from './ExchangeMessage/ExchangeMessage'
import RefundMessage from './RefundMessage/RefundMessage'
import * as Styles from './styles'

const exchangeTransactionTypes = [orderTransactionTypes.exchange, orderTransactionTypes.mixed]

const SummaryMessage = ({
  isInstantExchange,
  orderAmount,
  needsRefund,
  refundType,
  transactionType,
  issueRefundAtStatus,
  isCancellationsPortal,
}) => {
  return (
    <Styles.InfoContainer>
      {exchangeTransactionTypes.includes(transactionType) && <ExchangeMessage instant={isInstantExchange} />}
      {needsRefund && (
        <RefundMessage
          refundType={refundType}
          orderAmount={orderAmount}
          issueRefundAtStatus={issueRefundAtStatus}
          isCancellationsPortal={!isInstantExchange && isCancellationsPortal}
        />
      )}
    </Styles.InfoContainer>
  )
}

export default SummaryMessage
